<template lang="pug">
div(
    :class="{ checked: modelValue, external, disabled, error }"
    class="input-checkbox"
    @click="handleCheckToggle"
)
    transition(
        name="checkbox"
    )
        Check(
            v-if="modelValue"
            size="15"
        )
</template>

<script setup>
import Check from 'widget-components/assets/svg/Check.vue'

const props = defineProps({
    modelValue: Boolean,
    disabled: Boolean,
    external: Boolean,
    error: Boolean,
})

const emit = defineEmits(['update:modelValue'])

const handleCheckToggle = () => {
    if (props.disabled) {
        return
    }
    emit('update:modelValue', !props.modelValue)
}
</script>

<style scoped lang="sass">
@import './CheckTrigger.sass'
</style>
